'use client';



import { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { apiService } from '../../../services/ApiService';
import { ICommonCategoryMeta } from '../../../models/ICategory';
import Loader from '../svg/Loader';
import Switch from 'react-switch';
import News from '../svg/News';
import { useMutation, useQuery } from '@tanstack/react-query';
import Autocomplete from '../Autocomplete';



export default function NewsForm({close}:{close: Function}) {


  const [allSelected, setAllSelected] = useState(true);
  const [state,setState] = useState<{firstName: string; lastName: string; email: string; selectedCategorySlugs: string[]}>({selectedCategorySlugs: [],email: '',firstName: '', lastName: ''}) ;

  const { 
    data: categories,
    isLoading: isLoadingCategories,
    isPending: isPendingCategories,
    error: categoriesError
  } = useQuery(
    {
      enabled: !allSelected,
      queryKey: ['newsletter-categories'],
      queryFn: () => apiService.listCategories().then(x => x.filter(y => y.showInNewsletter))
    }
  );

  const { 
    mutate,
    isPending,
    error,
    reset
  } = useMutation(
    {
      mutationFn: () => {
        const payload = {
          firstName: state.firstName,
          lastName: state.lastName,
          email: state.email,
          ...(allSelected ? {allCategories: true} : {selectedCategorySlugs: state.selectedCategorySlugs})

        }
        return apiService.subscribeToNewsLetter(payload)
      },
      onSuccess: () => {
        close();
      }
    }
  );

  const handleChange = (e: ChangeEvent<any>) => {
    const {name, value} = e.target;
    setState(prevState => ({...prevState, [name]: value}))
  }
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (error) reset();
    mutate();

  } 

  return (
    <form onSubmit={handleSubmit} className='flex flex-col w-full overflow-y-auto overflow-x-hidden max-h-[calc(100vh-48px)] h-full justify-between'>
          <div className='flex flex-col'>
      <div className='flex flex-col w-full items-center mb-[24px]'>
        <News className='h-[78px] w-[78px] mb-[24px]'/>
        <h2 className='text-dark dark:text-white font-medium mb-[6px] text-center'>اشترك معنا</h2>
        <h6 className='text-dark dark:text-white text-center'>احصل على تحديثات حول المواضيع التي تختارها</h6>
      </div>

      <div className='grid grid-cols-1 desktop:grid-cols-2 gap-[16px] mb-[12px]'>
        <TextField
        onChange={handleChange}
        name='firstName'
        placeholder='الاسم الأول'
        value={state.firstName}
        className='desktop:col-span-1'
        />
        <TextField
        onChange={handleChange}
        name='lastName'
        placeholder='اسم العائلة'
        value={state.lastName}
        className='desktop:col-span-1'
        />
        <TextField
        onChange={handleChange}
        name='email'
        type='email'
        placeholder='البريد الالكتروني'
        value={state.email}
        className='desktop:col-span-full'
        />
        <div>

        </div>
      </div>


      <div className='flex flex-col gap-y-[16px] w-full mb-[24px]'>
          <div className='flex items-center col-span-full w-full tablet:w-[calc(50%-20px)] gap-[24px] justify-between pl-[12px]'>
            <span className='text-dark dark:text-white h6'>جميع المواضيع</span>
                 <Switch
                 dir='ltr'
              width={36}
              height={20}
              onColor='#f0f0f0'
              offColor='#ff00fe'
              checkedIcon={<></>}
              uncheckedIcon={<></>}
              checked={!allSelected} 
              onChange={checked => setAllSelected(!checked)
            }/>
            </div>
        {allSelected ? null : isLoadingCategories || isPendingCategories ? <Loader className='col-span-full mx-auto'/> : 
          categoriesError ? <span  className='text-danger col-span-full'>{String(categoriesError?.message || categoriesError)}</span> :
          <div>
           {categories?.length ? (

        <Autocomplete
        options={categories?.map(c => ({id: c.uniqueCode, title: c.title})) || []}
        selected={state.selectedCategorySlugs}
        setSelected={(selected: string[]) => setState(prevState => ({...prevState, selectedCategorySlugs: selected}))}
        />
      ) : null}
          </div>
        }
      </div>

</div>
    <div className='flex flex-col'>


      <div className='flex items-center justify-center w-full gap-[16px] mb-[24px]'>
        {
          isPending ? <Loader className='mx-auto'/> :
          error ? <span className='text-center text-danger'>{String(error.message || error)}</span> : (
            <>
              {/* <button type='button' className='grid place-items-center h-[42px] px-[24px] h6 cursor-pointer text-dark bg-white border border-darkBorder rounded-[8px] font-medium leading-none' onClick={() => close()}>إلغاء</button> */}
              <button className='grid place-items-center h-[42px] px-[24px] h6 cursor-pointer text-white bg-primary rounded-[8px] font-medium leading-none disabled:cursor-not-allowed disabled:opacity-60' type='submit' disabled={(allSelected ? false : !state.selectedCategorySlugs.length) || !state.firstName || !state.lastName || !state.email}>اشتراك</button>
            </>
          )
        }

      </div>
<span className='sm text-dark dark:text-white'>باشتراكك، فإنك توافق على استلام تحديثات عبر البريد الإلكتروني بناءً على الموضوعات التي اخترتها، كما أنك تقرّ بموافقتك على <a className='text-primary' href='https://www.foochia.com/privacy-policy' target='_blank'>سياسة الخصوصية</a> و <a className='text-primary' href='https://www.foochia.com/terms-of-service' target='_blank'>شروط الاستخدام</a> الخاصة بنا.</span>
    </div>
    </form>
  )
}


function TextField ({
  onChange,
  placeholder,
  value,
  className,
  name,
  type = 'text'
}:{
  className?: string; 
  value: string; 
  onChange: any;
  placeholder: string;
  name: string;
  type?: string;
}) {
  return (
    <div className={twMerge('flex items-center px-[14px] py-[10px] rounded-[8px] bg-gray-0 dark:bg-quinary border border-gray-200 dark:border-lightBorder', className)}>
      <input
        className='outline-none border-none bg-transparent sm text-dark w-full h-full'
        value={value}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        type={type}
        required
      />

    </div>
  )
}